import { Icon } from '@gftg/ui';
import { useLocation, Link } from 'react-router';
import { useSavedSessions } from '../lib/savedSessions';
import { isTabActive, TABS } from '../lib/tabs';

/**
 * The bar the design puts on every screen except the home screen and sign-in: home is the hub
 * and carries the footer instead, and sign-in has nowhere to navigate to yet.
 *
 * It is fixed to the viewport rather than the column, so it stays put while the agenda scrolls,
 * and constrained to the same width as the column so it lines up on a desktop window. From 1024px
 * up the same five destinations are in a header across the top instead, where a bar pinned to the
 * bottom of a laptop screen is a long way from anything the eye is on.
 */
export function TabBar() {
  const saved = useSavedSessions();
  const { pathname } = useLocation();

  return (
    <nav
      aria-label="Main"
      // The side borders are the column's, not the bar's: it is pinned to the viewport rather than
      // to the column, so on a tablet-width screen its edges have to be drawn to line up with the
      // sheet it sits at the bottom of.
      className="fixed bottom-0 left-1/2 z-20 w-full max-w-screen-sm -translate-x-1/2 border-t border-border-2 bg-surface pb-[env(safe-area-inset-bottom)] sm:border-x sm:border-x-border lg:hidden"
    >
      <ul className="grid grid-cols-5">
        {TABS.map((tab) => {
          const isActive = isTabActive(tab, pathname);

          return (
            <li key={tab.to}>
              <Link
                to={tab.to}
                aria-current={isActive ? 'page' : undefined}
                className="flex min-h-tabbar flex-col items-center justify-center gap-1"
              >
                <span className="relative">
                  <Icon
                    name={tab.icon}
                    size={23}
                    strokeWidth={isActive ? 2 : 1.5}
                    className={isActive ? 'text-ink' : 'text-ink-4'}
                  />
                  {tab.to === '/schedule' && saved.ids.size > 0 && (
                    <span className="absolute -top-1 -right-2.5 flex size-4 items-center justify-center rounded-full bg-brand text-[0.6rem] font-bold text-white tabular-nums">
                      {saved.ids.size}
                    </span>
                  )}
                </span>
                <span
                  className={`text-chip ${
                    isActive ? 'font-semibold text-ink' : 'font-medium text-ink-4'
                  }`}
                >
                  {tab.label}
                </span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
